export var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ../app_shared/~/apollo-client/core/types.js
// module id = 69
// module chunks = 1